import {AbstractDTO} from "@signature-it/ngx-generic/models";

export class QuickPadDTO extends AbstractDTO {

    sku: string;
    qty: number;
    status: string;
    pid: any;
    pic: string;
    link: string;
    fixedLotMultiplier: number;
    requestKeyword: string;
    name: string;
    class: string;

    constructor(attributes: Object) {
        super(attributes);
        attributes = attributes || {};

        this.sku = (attributes['sku']) ? attributes['sku'] : (attributes['request_keyword']) ? attributes['request_keyword'] : '';
        this.qty = attributes['qty'] && parseInt(attributes['qty']) ? parseInt(attributes['qty']) : 1;
        this.status = attributes['status'] || '';
        this.pid = attributes['pid'] || null;
        this.pic = attributes['pic'] || '';
        this.link = attributes['link'] || '';
        this.fixedLotMultiplier = attributes['fixed_lot_multiplier'] || 1;
        this.requestKeyword = attributes['request_keyword'] || '';
        this.name = attributes['name'] || '';
        this.class = null;

        if (attributes['data']) {
            this.sku = attributes['data']['sku'] ? attributes['data']['sku'] : attributes['data']['request_keyword'] ? attributes['data']['request_keyword'] :  this.sku;
            this.pid = attributes['data']['pid'] || this.pid;
            this.pic = attributes['data']['pic'] || this.pic;
            this.link = attributes['data']['link'] || this.link;
            this.fixedLotMultiplier = attributes['data']['fixed_lot_multiplier'] || this.fixedLotMultiplier;
            this.requestKeyword = attributes['data']['request_keyword'] || this.requestKeyword;
            this.name = attributes['data']['name'] || this.name;
            this.qty = attributes['data']['qty'] && parseInt(attributes['data']['qty']) ? parseInt(attributes['data']['qty']) : this.qty;
            this.class = null;
        }

    }

}
